var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          {
            ref: "submissionAgentSelectContainer",
            staticClass: "form-group-material",
            attrs: { id: "submission-agent-select-container" },
            on: { click: _vm.handleSelect2Click },
          },
          [
            _c("select2", {
              ref: "select",
              attrs: {
                id: "submission-agent-select",
                data: _vm.submissionAgentsValues,
                name: "submission-agent",
                options: _vm.select2Options,
                "init-on-mounted": false,
                "format-data": _vm.formatData,
                value: _vm.assignedSubmissionAgentId,
              },
              on: { change: _vm.handleSelect2Change },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("label", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
              _vm._v(
                _vm._s(_vm.$t("direct-to-lender.participants.submissionAgent"))
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("inline-loader", { staticClass: "pb-2 d-flex align-items-center" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-auto pb-2 d-flex justify-content-end align-items-center",
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-danger btn-sm mr-2",
              attrs: { type: "button" },
              on: { click: _vm.clearSubmissionAgentByButton },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("global.words.clear")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm",
              attrs: { type: "button" },
              on: { click: _vm.toggleAdd },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("global.actions.addNew")) + "\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.editing
        ? _c("submission-agent", {
            attrs: { "submission-agent": _vm.selectedSubmissionAgent },
            on: { add: _vm.handleAdd, edit: _vm.handleEdit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }